import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../hooks/useUser';
import { useModals } from '../hooks/useModals';
import { Box, CircularProgress } from '@mui/material';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useUser();
  const { handleOpenLogin } = useModals();
  const navigate = useNavigate();
  const [hasTriggeredModal, setHasTriggeredModal] = React.useState(false);

  React.useEffect(() => {
    if (!loading && !isAuthenticated && !hasTriggeredModal) {
      handleOpenLogin();
      setHasTriggeredModal(true);
    }
  }, [loading, isAuthenticated, handleOpenLogin, hasTriggeredModal]);

  if (loading || !isAuthenticated) {
    return (
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          minHeight: '400px' 
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return children;
};

export default ProtectedRoute;
